import React from 'react';

const BASENAME = process.env.PUBLIC_URL;

const CamerasCellRenderer = ({value, data}) => {
    const { ibge} = data;

    const openCameras = () => {
        window.open(`${BASENAME}/cameras/${ibge}`, `cameras-${ibge}`);
    }

    return (
        <div className={"text-blue-700 w-full hover:underline"} onClick={openCameras}>
            {value}
        </div>
    );
};

export default CamerasCellRenderer;